"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var gl_resource_1 = __importDefault(require("./gl-utils/gl-resource"));
var fbo_1 = __importDefault(require("./gl-utils/fbo"));
var Parameters = __importStar(require("./parameters"));
var FluidShaders = __importStar(require("./shaders/fluid-shaders"));
require("./page-interface-generated");
var Fluid = (function (_super) {
    __extends(Fluid, _super);
    function Fluid(gl, width, height) {
        var _this = _super.call(this, gl) || this;
        _this._useFloatTextures = false;
        _this.viscosity = 0.0002;
        _this.colorIntensity = 0.033;
        _this.color = true;
        _this.reset(width, height);
        return _this;
    }
    Fluid.prototype.freeGLResources = function () {
        if (this._FBO) {
            this._FBO.freeGLResources();
        }
        this.freeTextures();
        this.freeShaders();
    };
    Fluid.prototype.freeTextures = function () {
        var gl = _super.prototype.gl.call(this);
        if (this._velTextures) {
            gl.deleteTexture(this._velTextures[0]);
            gl.deleteTexture(this._velTextures[1]);
        }
        gl.deleteTexture(this._tmpTexture);
        gl.deleteTexture(this._pressureTexture);
        gl.deleteTexture(this._divergenceTexture);
    };
    Fluid.prototype.freeShaders = function () {
        function freeShader(shader) {
            if (shader) {
                shader.freeGLResources();
            }
        }
        freeShader(this._drawVelocityShader);
        freeShader(this._drawPressureShader);
        freeShader(this._addVelShader);
        freeShader(this._advectShader);
        freeShader(this._jacobiPressureShader);
        freeShader(this._divergenceShader);
        freeShader(this._substractGradientShader);
        freeShader(this._obstaclesVelocityShader);
    };
    Fluid.prototype.reset = function (width, height) {
        this.freeGLResources();
        this._width = width;
        this._height = height;
        this.dx = 1 / Math.min(width, height);
        this._FBO = new fbo_1.default(_super.prototype.gl.call(this), width, height);
        this.initTextures();
        this.buildShaders();
        this._currIndex = 0;
    };
    Object.defineProperty(Fluid.prototype, "useFloatTextures", {
        set: function (bool) {
            if (bool !== this._useFloatTextures) {
                this._useFloatTextures = bool;
                this.reset(this._width, this._height);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fluid.prototype, "minNbIterations", {
        set: function (value) {
            this._nbIterations = 2 * Math.ceil(value / 2) + 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fluid.prototype, "texelSize", {
        get: function () {
            return [1 / this._width, 1 / this._height];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fluid.prototype, "velTexture", {
        get: function () {
            return this._velTextures[this.currIndex];
        },
        enumerable: false,
        configurable: true
    });
    Fluid.prototype.update = function (obstacleMap) {
        var gl = _super.prototype.gl.call(this);
        var dt = this.timestep;
        gl.clearColor(0.5, 0, 0.5, 0);
        if (Page.Canvas.isMouseDown()) {
            var canvas = gl.canvas;
            var canvasSize = [canvas.clientWidth, canvas.clientHeight];
            var brushSize = [
                Parameters.brush.radius / canvasSize[0],
                Parameters.brush.radius / canvasSize[1]
            ];
            var pos = Parameters.mouse.pos;
            var vel = [
                Parameters.mouse.movement[0] * Parameters.brush.strength,
                Parameters.mouse.movement[1] * Parameters.brush.strength,
            ];
            this.addVel(pos, brushSize, vel);
        }
        this.advect(dt);
        this.obstaclesVelocity(obstacleMap);
        this.project(obstacleMap);
        this.obstaclesVelocity(obstacleMap);
    };
    Fluid.prototype.addVel = function (pos, size, vel) {
        var gl = this.gl();
        var addVelShader = this._addVelShader;
        addVelShader.u["uVel"].value = this._velTextures[this.currIndex];
        addVelShader.u["uBrushPos"].value = pos;
        addVelShader.u["uBrushSize"].value = size;
        addVelShader.u["uAddVel"].value = vel;
        addVelShader.use();
        this._FBO.bind([this._velTextures[this.nextIndex]]);
        addVelShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        this.switchBuffers();
    };
    Fluid.prototype.drawVelocity = function () {
        var gl = this.gl();
        var drawShader = this._drawVelocityShader;
        drawShader.u["uVel"].value = this._velTextures[this.currIndex];
        drawShader.u["uColorIntensity"].value = this.colorIntensity;
        drawShader.u["uBlacknWhite"].value = !this.color;
        drawShader.use();
        drawShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    Fluid.prototype.drawPressure = function () {
        var gl = this.gl();
        var drawPressureShader = this._drawPressureShader;
        drawPressureShader.u["uPressure"].value = this._pressureTexture;
        drawPressureShader.u["uColorIntensity"].value = this.colorIntensity;
        drawPressureShader.u["uBlacknWhite"].value = !this.color;
        drawPressureShader.use();
        drawPressureShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    Object.defineProperty(Fluid.prototype, "currIndex", {
        get: function () {
            return this._currIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Fluid.prototype, "nextIndex", {
        get: function () {
            return (this._currIndex + 1) % 2;
        },
        enumerable: false,
        configurable: true
    });
    Fluid.prototype.switchBuffers = function () {
        this._currIndex = this.nextIndex;
    };
    Fluid.prototype.obstaclesVelocity = function (obstacleMap) {
        var gl = this.gl();
        var obstacleVelocityShader = this._obstaclesVelocityShader;
        obstacleVelocityShader.u["uVelocities"].value = this._velTextures[this.currIndex];
        obstacleVelocityShader.u["uObstacles"].value = obstacleMap.texture;
        obstacleVelocityShader.u["uTexelSize"].value = this.texelSize;
        this._FBO.bind([this._velTextures[this.nextIndex]]);
        obstacleVelocityShader.use();
        obstacleVelocityShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        this.switchBuffers();
    };
    Fluid.prototype.advect = function (dt) {
        var gl = this.gl();
        var advectShader = this._advectShader;
        advectShader.u["uVelUnit"].value = [128 / this._width, 128 / this._height];
        advectShader.u["uDt"].value = dt;
        advectShader.u["uQuantity"].value = this._velTextures[this.currIndex];
        advectShader.u["uVel"].value = this._velTextures[this.currIndex];
        this._FBO.bind([this._velTextures[this.nextIndex]]);
        advectShader.use();
        advectShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        this.switchBuffers();
    };
    Fluid.prototype.computeDivergence = function () {
        var gl = this.gl();
        var divergenceShader = this._divergenceShader;
        divergenceShader.u["uTexelSize"].value = this.texelSize;
        divergenceShader.u["uVelocity"].value = this._velTextures[this.currIndex];
        this._FBO.bind([this._divergenceTexture]);
        gl.clear(gl.COLOR_BUFFER_BIT);
        divergenceShader.use();
        divergenceShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    };
    Fluid.prototype.computePressure = function (obstacleMap) {
        var gl = this.gl();
        var jacobiPressureShader = this._jacobiPressureShader;
        var alpha = -.5 * this.dx;
        var beta = 4;
        var dst = this._pressureTexture;
        var cstTerm = this._divergenceTexture;
        jacobiPressureShader.u["uTexelSize"].value = this.texelSize;
        jacobiPressureShader.u["uAlpha"].value = alpha;
        jacobiPressureShader.u["uInvBeta"].value = 1 / beta;
        jacobiPressureShader.u["uConstantTerm"].value = cstTerm;
        jacobiPressureShader.u["uObstacles"].value = obstacleMap.texture;
        var index = 0;
        var textures = [this._tmpTexture, dst];
        this._FBO.bind([this._tmpTexture]);
        gl.clear(gl.COLOR_BUFFER_BIT);
        jacobiPressureShader.use();
        jacobiPressureShader.bindAttributes();
        for (var i = 0; i < this._nbIterations; ++i) {
            jacobiPressureShader.u["uPrevIter"].value = textures[index];
            this._FBO.bind([textures[(index + 1) % 2]]);
            jacobiPressureShader.bindUniforms();
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
            index = (index + 1) % 2;
        }
    };
    Fluid.prototype.substractPressureGradient = function () {
        var gl = this.gl();
        var substractGradientShader = this._substractGradientShader;
        substractGradientShader.u["uVelocities"].value = this._velTextures[this.currIndex];
        substractGradientShader.u["uPressure"].value = this._pressureTexture;
        substractGradientShader.u["uTexelSize"].value = this.texelSize;
        substractGradientShader.u["uHalfInvDx"].value = 0.5 / this.dx;
        this._FBO.bind([this._velTextures[this.nextIndex]]);
        substractGradientShader.use();
        substractGradientShader.bindUniformsAndAttributes();
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        this.switchBuffers();
    };
    Fluid.prototype.project = function (obstacleMap) {
        this.computeDivergence();
        this.computePressure(obstacleMap);
        this.substractPressureGradient();
    };
    Fluid.prototype.initTextures = function () {
        this.freeTextures();
        var gl = _super.prototype.gl.call(this);
        var width = this._width;
        var height = this._height;
        var floatTexels = [];
        for (var i = 0; i < 4 * width * height; ++i) {
            floatTexels.push(0);
        }
        var floatData = new Float32Array(floatTexels);
        var uintTexels = [];
        for (var i = 0; i < 4 * width * height; ++i) {
            uintTexels.push(127);
        }
        var uintData = new Uint8Array(uintTexels);
        var velFormat = (this._useFloatTextures) ? gl.FLOAT : gl.UNSIGNED_BYTE;
        var velData = (this._useFloatTextures) ? floatData : uintData;
        var textures = [];
        for (var i = 0; i < 2; ++i) {
            var texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, velFormat, velData);
            textures.push(texture);
        }
        for (var i = 0; i < 3; ++i) {
            var texture = gl.createTexture();
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, uintData);
            textures.push(texture);
        }
        for (var _i = 0, textures_1 = textures; _i < textures_1.length; _i++) {
            var texture = textures_1[_i];
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        }
        gl.bindTexture(gl.TEXTURE_2D, null);
        this._velTextures = [textures[0], textures[1]];
        this._tmpTexture = textures[2];
        this._pressureTexture = textures[3];
        this._divergenceTexture = textures[4];
    };
    Fluid.prototype.buildShaders = function () {
        this.freeShaders();
        FluidShaders.setUseFloatTextures(this._useFloatTextures);
        var gl = _super.prototype.gl.call(this);
        this._drawVelocityShader = FluidShaders.buildDrawVelocityShader(gl);
        this._drawPressureShader = FluidShaders.buildDrawPressureShader(gl);
        this._addVelShader = FluidShaders.buildAddVelShader(gl);
        this._advectShader = FluidShaders.buildAdvectShader(gl);
        this._jacobiPressureShader = FluidShaders.buildJacobiPressureShader(gl);
        this._divergenceShader = FluidShaders.buildDivergenceShader(gl);
        this._substractGradientShader = FluidShaders.buildSubstractGradientShader(gl);
        this._obstaclesVelocityShader = FluidShaders.buildObstaclesVelocityShader(gl);
    };
    return Fluid;
}(gl_resource_1.default));
exports.default = Fluid;
